import axios from 'axios'
import { ElMessage } from 'element-plus'

// 从环境变量获取多个基础URL
const {
  VUE_APP_API_URL: apiUrl,
  VUE_APP_OTHER_URL: otherUrl
} = process.env

// 创建多个axios实例
const createInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000
  })

  // 通用请求拦截
  instance.interceptors.request.use(
    config => {
      // const token = localStorage.getItem('token')
      // if (token) {
      //   config.headers['Authorization'] = `Bearer ${token}`
      // }
      config.headers['referer-token'] = 'http://joyapper.com'
      return config
    },
    error => Promise.reject(error)
  )

  // 通用响应拦截
  instance.interceptors.response.use(
    response => {
      if (response.status !== 200) {
        ElMessage.error('网络请求失败：' + response.status)
        return Promise.reject(new Error(response.status))
      }
      return response
    },
    error => {
      ElMessage.error('网络请求错误：' + error.message)
      return Promise.reject(error)
    }
  )

  return instance
}

// 创建不同服务的实例
const request = {
  api: createInstance(apiUrl),
  other: createInstance(otherUrl)
}

export default request
